import * as React from "react";
import { FC } from "react";
import { Feature } from "ol";

export interface IDemoMiniMaps {
    routeList: Feature[];
    onToggleRouteMiniMap: (routeId: string, isOn: boolean) => void;
}
export const DemoMiniMaps: FC<IDemoMiniMaps> = ({ routeList, onToggleRouteMiniMap }: IDemoMiniMaps) => {
    const allRoutes = routeList && routeList.map((r) => ({ id: r.get("ROUTEID"), title: r.get("PLACENAME") }));

    return (
        <>
            {allRoutes
                ? allRoutes.map((route) => (
                      <div className="list-item" key={route.title}>
                          <input
                              type="checkbox"
                              id={"route" + route.title}
                              title={route.title}
                              defaultChecked={false}
                              onChange={(e) => onToggleRouteMiniMap(route.id, e.target.checked)}
                          ></input>
                          <label htmlFor={"route" + route.title}>{route.title}</label>
                      </div>
                  ))
                : null}
        </>
    );
};
